/**
 * Treatments Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";

// States
const state = {
    treatments: [],
    treatment: {}
};

// Getters
const getters = {
    treatments: state => {
        return state.treatments
    },

    treatment: state => {
        return state.treatment
    }
};

// Actions
const actions = {
    getTreatments(context, payload) {
        function successCallback(response) {
            context.commit('getTreatmentsHandler', { treatments: response.data.traitements });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Treatment.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getTreatment(context, payload) {
        function successCallback(response) {
            context.commit('getTreatmentHandler', { treatment: response.data.traitement });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Treatment.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createTreatment(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'treatments' });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Treatment.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateTreatment(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'treatments' });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Treatment.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteTreatment(context, payload) {
        function successCallback(response) {
            context.commit('deleteTreatmentHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Treatment.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getTreatmentsHandler(state, { treatments }) {
        // Update treatments state
        state.treatments = treatments;
    },

    getTreatmentHandler(state, { treatment }) {
        // Update treatment state
        state.treatment = treatment;
    },

    deleteTreatmentHandler(state, { index, successMessage }) {
        let i = state.treatments.findIndex(treatment => treatment.slug === index);

        if (~i) {
            state.treatments.splice(i, 1);

            router.push({ name: 'treatments' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}